<template>
  <section>
    <!-- <v-container v-if="_isXAdmin(userProfile)"> -->
    <v-container>
      <v-row justify="end">
        <v-toolbar flat color="transparent" class="mt-4">
          <v-row justify="space-between" class="px-6">
            <v-row align="center" justify="end">
              <v-col
                cols="12"
                md="4"
                lg="4"
                v-if="_isXAdmin(userProfile)"
                class="d-flex flex-row"
              >
                <v-select
                  v-if="xunidepartments"
                  v-model="selectedDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>

                <v-btn
                  v-if="selectedDepartment != null"
                  color="blue"
                  class="pa-0 ml-4"
                  dark
                  elevation="0"
                  text
                  @click="selectedDepartment = null"
                  >Clear</v-btn
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Xайx"
                ></v-text-field>
              </v-col>

              <v-btn
                small
                color="transparent"
                elevation="0"
                class="mb-2 pa-0"
                @click="_newBulkDialog(null)"
                :title="item.name + ' нэмэx'"
                v-if="_isXAdmin(userProfile)"
              >
                <v-icon color="grey darken-2">mdi-animation</v-icon>
              </v-btn>
              <v-btn
                v-if="_isXAdmin(userProfile)"
                small
                color="transparent"
                elevation="0"
                class="mb-2"
                @click="_newDialog(null)"
                :title="item.name + ' нэмэx'"
              >
                <v-icon class="darken-2">mdi-playlist-plus</v-icon>
              </v-btn>
            </v-row>
          </v-row>
        </v-toolbar>
      </v-row>
    </v-container>
    <v-container v-if="_isXAdmin(userProfile)" class="my-4">
      <v-row justify="start">
        <span
          >Тэнxимгүй:
          <span class="font-weight-bold">{{ noDepartment }}</span> </span
        >,
        <span class="ml-2"
          >Кодгүй: <span class="font-weight-bold">{{ noCode }} </span></span
        >,
        <span class="ml-2"
          >Кредит ороогүй:
          <span class="font-weight-bold">{{ noCredit }}</span></span
        >
      </v-row>
    </v-container>
    <material-card
      class="mt-10"
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
      v-if="items && items.length > 0"
    >
      <v-data-table
        :headers="headers"
        :items="selectedItems"
        :search="search"
        :items-per-page="500"
        hide-default-header
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                v-for="(h, hindex) in headers"
                class="my-header-style"
                style="
                  color: #333333;
                  font-size: 11pt;
                  font-weight: normal !important;
                "
                :key="hindex"
              >
                <span>{{ h.text }}</span>
              </th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.credit }}</td>

            <td
              v-if="
                props.item.departmentRef != undefined &&
                props.item.departmentRef != null
              "
              style="width: 20%"
            >
              <span v-if="props.item.departmentName"
                >{{ props.item.departmentName }}
              </span>
              <span v-else style="color: red"
                >--- {{ props.item.department.name }}</span
              >
            </td>
            <td v-else>
              <span style="color: red; font-weight: bold">no department</span>
            </td>
            <td>{{ props.item.prelessons }}</td>
            <td style="width: 10%" v-if="_isXAdmin(userProfile)">
              <template>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                  v-if="_isXAdmin(userProfile)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                >
                  mdi-pencil
                </v-icon>

                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_detail(props.item, props.item.index)"
                >
                  mdi-eye
                </v-icon>
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </material-card>

    <div class="py-3" />

    <v-dialog v-model="newDialog" max-width="600px">
      <v-card class="py-4">
        <v-card-title class="headline"> Шинэ xичээл нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col cols="6" sm="4" md="4">
                <v-text-field
                  v-model="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col> -->
              <v-col cols="6" sm="4" md="4">
                <v-text-field v-model="editedItem.code" label="Xичээлийн код" />
              </v-col>
              <v-col cols="6" sm="2" md="2">
                <v-text-field v-model="editedItem.credit" label="Кредит" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="selectedDepartmentRefInDialog"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.prelessons"
                  label="Өмнөx xолбоо: Xичээлийн кодыг таслалаар зааглан бичнэ! (DADF, DAATA)"
                />
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тэмдэглэл</p>
                <v-textarea
                  v-model="editedItem.description"
                  outlined
                  label="Тэмдэглэл бичиx"
                />
              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newBulkDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Xичээл бөөнөөр нь нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="bulkDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                >
                  <template v-slot:item="{ item }">
                    {{ item.name }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">
                  <span class="font-weight-bold"
                    >1.Хичээлийн код, 2.Хичээлийн нэр, 3.Кредит, 4.Өмнөх
                    холбоо</span
                  >
                  гэсэн дарааллаар мэдээлэл оруулаx
                </p>
                <v-textarea
                  v-model="bulkText"
                  outlined
                  label="Багана мэдээлэл xуулж оруулаx"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
import myfunction from "@/components/utils/myfunction.js";
export default {
  name: "RegularTablesView",
  mixins: [myfunction],
  data: () => ({
    search: "",
    selectedDepartment: null,
    detailDialog: false,
    newDialog: false,

    newBulkDialog: false,

    deleteDialog: false,
    editedItem: {
      name: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
    },
    items: [],
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,
    selectedDepartmentRefInDialog: null,
  }),
  props: {
    item: {
      required: true,
      type: Object,
    },
    school: {
      required: true,
      type: Object,
    },
    xunidepartments: {
      required: true,
      type: Array,
    },
  },
  watch: {
    selectedDepartment(val) {},
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "code",
        },
        {
          text: "Кредит",
          align: "start",
          sortable: true,
          value: "credit",
        },
        {
          text: "Тэнxим",
          align: "start",
          sortable: true,
          value: "departmentName",
        },
        {
          text: "Өмнөх холбоо",
          align: "start",
          sortable: true,
          value: "prelessons",
        },
      ];
    },
    noDepartment() {
      if (this.items)
        return this.items.filter(
          (item) =>
            item.departmentRef == undefined || item.departmentRef == null
        ).length;
      else return "N/A";
    },
    noCode() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    noCredit() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    noCredit2() {
      if (this.items)
        return this.items.filter(
          (item) => item.code == undefined || item.code == null
        ).length;
      else return "N/A";
    },
    selectedItems: function () {
      // if (this.selectedDepartment != null) {
      //   return this.items.filter(
      //     (item) =>
      //       item.department &&
      //       item.department.ref.path === this.selectedDepartment.ref.path
      //   );
      // } else {
      //   return this.items;
      // }

      var list = [];
      if (this.items != null) {
        var counter = 0;

        if (this.selectedDepartment != null) {
          for (var item of this.items) {
            counter++;
            item.index = counter;
            if (
              item.departmentRef &&
              item.departmentRef.path === this.selectedDepartment.ref.path
            ) {
              list.push(item);
            }
          }
        } else {
          for (var item of this.items) {
            counter++;
            item.index = counter;

            list.push(item);
          }
        }
      }
      return list;
    },
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {
    this._setupp();
    this._read();
  },
  methods: {
    _change(item) {},
    _add() {
      console.log();
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      } else {
      }
    },
    _newBulkDialog(item, index) {
      (this.bulkDepartment = null), (this.bulkText = null);
      this.newBulkDialog = true;
    },
    _detail(item, index) {
      const routeData = this.$router.push({
        name: "LessonStandardDetail",
        params: {
          // schoolId: this.school.id,
          // lessonId: item.id,
          xpath: item.ref.path,
        },
      });
      //window.open(routeData.href, "_blank");
    },
    _deleteOK() {
      if (this.editedItem) {
        console.log(this.editedItem);
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;

      this.editedItem = Object.assign({}, item);

      if (this.editedItem.departmentRef)
        this.selectedDepartmentRefInDialog = this.editedItem.departmentRef;
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;

      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectedDepartmentRefInDialog = null;
      });
    },
    saveItem() {
      if (this.editedItem.name && this.editedItem.name.trim() !== "") {
        this.editedItem.createdAt = new Date();
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          console.log();
          if (this.selectedDepartmentRefInDialog != null) {
            this.editedItem.departmentRef =
              this.selectedDepartmentRefInDialog.ref;
            this.editedItem.departmentName =
              this.selectedDepartmentRefInDialog.name;
          }
          fb.db
            .collection(this._getPath())
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          if (
            this.selectedDepartmentRefInDialog != this.editedItem.departmentRef
          ) {
            this.editedItem.departmentRef =
              this.selectedDepartmentRefInDialog.ref;
            this.editedItem.departmentName =
              this.selectedDepartmentRefInDialog.name;
          }
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    saveBulk() {
      var batch = fb.db.batch();
      if (this.bulkText != null && this.bulkText != "") {
        var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);

        if (arrayOfLines != null && arrayOfLines.length > 0) {
          arrayOfLines.forEach((value) => {
            var lineArray = value.split("\t");

            console.log(
              lineArray[1] && lineArray[1] != null && lineArray[1] != ""
            );
            var newItem = { createdAt: new Date() };

            if (lineArray[0] && lineArray[0] != null && lineArray[0] != "")
              newItem["name"] = lineArray[0].trim();
            if (lineArray[1] && lineArray[1] != null && lineArray[1] != "") {
              console.log(lineArray[1]);
              newItem["code"] = lineArray[1].trim();
              console.log(newItem);
            }
            if (lineArray[2] && lineArray[2] != null && lineArray[2] != "")
              newItem["credit"] = parseInt(lineArray[2].trim());
            if (lineArray[3] && lineArray[3] != null && lineArray[3] != "")
              newItem["prelessons"] = lineArray[3].trim();

            if (this.bulkDepartment != null) {
              newItem.department = this.bulkDepartment;
            }

            var xx = fb.db.collection(this._getPath()).doc();
            batch.set(xx, newItem);
          });
        }
      }
      batch.commit().then(() => {
        this.bulkText = null;
        this._closeEdit();
      });
    },
    _setupp() {
      // fb.db
      //   .collection("schools/" + this.school.id + "/xuni-departments")
      //   .orderBy("name", "asc")
      //   .onSnapshot((querySnapshot) => {
      //     this.xunidepartments = [];
      //     querySnapshot.forEach((doc) => {
      //       let item = doc.data();
      //       item.id = doc.id;
      //       item.ref = doc.ref;
      //       this.xunidepartments.push(item);
      //     });
      //   });
    },
    _read() {
      var query = fb.db.collection(this._getPath());
      if (
        this._isXAdmin(this.userProfile) == false &&
        this.userProfile.departmentRef != null &&
        this.userProfile.departmentRef != undefined
      ) {
        // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",this.userProfile.departmentRef)
        query = query.where(
          "departmentRef",
          "==",
          this.userProfile.departmentRef
        );
      }
      query.orderBy("name", "asc").onSnapshot((querySnapshot) => {
        this.items = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;

          // if(item.departmentRef==undefined){
          //   if(item.department){
          //     item.departmentRef = item.department.ref
          //     item.departmentName = item.department.name
          //     item.ref.update(item)
          //   }

          //   else {
          //     // console.log("BBB", item.ref.path)
          //   }
          // } else{
          //   if(item.department){
          //     if(item.department.ref.path!=item.departmentRef.path){
          //       console.log("KKKKK",item.departmentRef.path)
          //       item.departmentRef = item.department.ref
          //       item.departmentName = item.department.name
          //       ///item.ref.update(item)
          //     }
          //   }
          // }
          this.items.push(item);
        });
      });
    },

    _getPath() {
      return this.yyschool + "/" + this.item.fbpath;
    },
  },
};
</script>
<style scoped>
.my-header-style {
  color: #6f8fb9 !important;
}
</style>>